var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"globalDisclaimers"},[_c('div',{staticClass:"disclaimerScroll",attrs:{"id":"loginTermsBox"},domProps:{"innerHTML":_vm._s(_vm.terms)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }